import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/student-portal-dashboard/components/StudentPortalInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
